<div class="team-dashboard">
  <div class="tenant-filter">
    <form [formGroup]="form">
      <div class="filter-control-group">
        <label class="label" for="team">Team</label>
        <wr-team-select
          [fixedTenantId]="currentTenantId()"
          (teamSelected)="onTeamSelected($event)">
        </wr-team-select>
      </div>
    </form>
  </div>

  <div class="team-dashboard-grid" *ngIf="selectedTeam; else noTeamSelected">
    <wr-team-dashboard-info [team]="selectedTeam"></wr-team-dashboard-info>
    <wr-team-dashboard-map [team]="selectedTeam"></wr-team-dashboard-map>
  </div>

  <ng-template #noTeamSelected>
    <div class="empty-state-message">
      Bitte wählen Sie ein Team aus.
    </div>
  </ng-template>
</div>
